import React from 'react';
import Header from '../Pages/Includes/Header';
import { Outlet, useLocation } from 'react-router-dom';


const Layout = () => {
    const location = useLocation();
    const hideHeaderPaths = ["/quiz/bonus", "/quiz/bonus/result"];
    const hideHeader = hideHeaderPaths.includes(location.pathname) || location.pathname.startsWith("/quiz/start/");
    const search = location.pathname === '/search';

    return (
        <>
            <div className="main-wrapper">

                <div className="overlay"></div>

                {!hideHeader && <Header />}

                <main className={`main-wrp ${hideHeader || search ? 'm-0' : ''}`}>
                    <Outlet />
                </main>
            </div>
        </>
    );
};

export default Layout;